export const LOGIN_LOGO_URL = `${process.env.PUBLIC_URL}/assets/images/nafdaq-logo.jpg`;
export const BRAND_WEBSITE_URL = "https://nafdak.eu/";
